import { CustomerStateInterface } from "./types";
import Customer from "@/types/customer/Customer";
import Investment from "@/types/app/investment";
import Notification from "@/types/app/notifications";
import Schedule from "@/types/app/schedules";

export default {
  getCustomers(state: CustomerStateInterface): Customer[] {
    return state.customers.filter((x) => x.status == 1);
  },
  getCustomersAll(state: CustomerStateInterface): Customer[] {
    return state.customers;
  },

  getCustomersEnabledNotification(state: CustomerStateInterface): Customer[]{
    return state.customers.filter((x) => x.status == 1 && x.subscriptionStatus == 'Subscibed');
  },

  getPendings(state: CustomerStateInterface): Customer[] {
    return state.customers.filter((x) => x.status == 0);
  },
  getRefuseds(state: CustomerStateInterface): Customer[] {
    return state.customers.filter((x) => x.status == 2);
  },
  getActiveCustomers(state: CustomerStateInterface): Customer[] {
    return state.customers.filter((x) => x.status == 0 || x.status == 1);
  },
  getCustomer(state: CustomerStateInterface): Customer {
    return state.customer;
  },
  getLoading(state: CustomerStateInterface): boolean {
    return state.loading;
  },
  getModalInterestState(state: CustomerStateInterface): boolean {
    return state.modalInterest;
  },
  getModalCreateInterestState(state: CustomerStateInterface): boolean {
    return state.modalCreateInterest;
  },
  getModalAccountMirrorState(state: CustomerStateInterface): boolean {
    return state.modalAccountMirror;
  },
  getModalImportInterestState(state: CustomerStateInterface): boolean {
    return state.modalImportInterest;
  },
  getModalInvestmentState(state: CustomerStateInterface): boolean {
    return state.modalInvestment;
  },
  getModalNewNotificationState(state: CustomerStateInterface): boolean {
    return state.modalNewNotification;
  },
  getModalNotificationState(state: CustomerStateInterface): boolean {
    return state.modalNotification;
  },
  getModalJobInfoState(state: CustomerStateInterface): boolean {
    return state.modalJobInfo;
  },
  getModalCustomerState(state: CustomerStateInterface): boolean {
    return state.modalCustomer;
  },
  getModalRefusedState(state: CustomerStateInterface): boolean {
    return state.modalRefused;
  },
  getModalRefuseState(state: CustomerStateInterface): boolean {
    return state.modalRefuse;
  },
  getModalMessageState(state: CustomerStateInterface): boolean {
    return state.modalMessage;
  },
  getInvesmentState(state: CustomerStateInterface): Investment {
    return state.investment;
  },
  getNotificationState(state: CustomerStateInterface): Notification {
    return state.notification;
  },
  getNotificationsState(state: CustomerStateInterface): Notification[] {
    return state.notifications;
  },
  getNotificationSent(state: CustomerStateInterface): boolean {
    return state.notificationSent;
  }, 
  getModalDeleteState(state: CustomerStateInterface): boolean {
    return state.ModalDeleteState;
  },
  getUndoRefused(state: CustomerStateInterface): boolean {
    return state.undoRefused;
  }, 

  getScheduleState(state: CustomerStateInterface): Schedule {
    return state.schedule;
  },
  getModalScheduleState(state: CustomerStateInterface): boolean {
    return state.modalSchedule;
  },
  getScheduleFeedbackModalState(state: CustomerStateInterface): boolean {
    return state.scheduleFeedbackModal;
  },
};
